import * as React from 'react';
import { Input } from '../../../components/Bootstrap';
import { DrinkEditorRow } from './DrinkEditorRow';

interface DrinkEditorInputRowProps {
  label: string;
  required: boolean;
  name: string;
  value: string;
  type: string;
  disabled?: boolean;
  className?: string;
  onChange(value: string);
}

export const DrinkEditorInputRow: React.FC<DrinkEditorInputRowProps> = (props) => {
  const onChange = React.useCallback(
    (e) => {
      props.onChange(e.target.value);
    },
    [props]
  );

  return (
    <DrinkEditorRow for={props.name} label={props.label}>
      <Input
        required={props.required}
        type={props.type}
        name={props.name}
        id={props.name}
        value={props.value}
        onChange={onChange}
        className={props.className}
        disabled={props.disabled}
      />
    </DrinkEditorRow>
  );
};
